import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { PEPRequestsRow } from './PEPRequestsRow';
import { TableWrapper, ColumnHeader, TableHeaderRow, SectionMessage } from './PEPRequests.style';
import { PEPState } from 'src/components/FraudAndCompliance/PEPTab/PEPState';
import { notificationCountsItems } from 'src_server/types';
import { PepXmlWrapper } from 'src/components/FraudAndCompliance/PEPTab/PEP/PepXml/PepXml';

const renderList = (PEPState: PEPState, list: notificationCountsItems.TSuccessResponse): Array<React.ReactNode> | React.ReactElement<any, any> => {
    const elements: Array<React.ReactNode> = [];

    for (const PEPElement of list) {
        elements.push(
            <PEPRequestsRow
                key={PEPElement.accountId}
                PEPElement={PEPElement}
                PEPState={PEPState}
            />
        );
    }

    return elements;
};

interface PropsType {
    PEPState: PEPState,
}

export const PEPRequests = observer('PEPRequests', (props: PropsType): React.ReactElement => {

    const PEPList = props.PEPState.list;

    if (PEPList.length === 0) {
        return (
            <div>
                <SectionMessage>There are no items</SectionMessage>
            </div>
        );
    }

    return (
        <div>
            <TableWrapper>
                <thead>
                    <TableHeaderRow>
                        <ColumnHeader>User ID</ColumnHeader>
                        <ColumnHeader>Date</ColumnHeader>
                        <ColumnHeader>Full Name</ColumnHeader>
                        <ColumnHeader>PEP Titles</ColumnHeader>
                        <ColumnHeader>Sanction Titles</ColumnHeader>
                        <ColumnHeader>Revieved</ColumnHeader>
                        <ColumnHeader>Check XML details</ColumnHeader>
                    </TableHeaderRow>
                </thead>
                <tbody>
                    {PEPList === null ? null : renderList(props.PEPState, PEPList)}
                </tbody>
            </TableWrapper>

            {props.PEPState.isOpenModal === true ?
                <PepXmlWrapper
                    closeModal={() => props.PEPState.toggleModal(null, false)}
                    accountId={props.PEPState.xmlAccountId}
                /> : null}
        </div>
    );
});
